import { ShapeStyle } from "../types/diagram.types";

export type ShapeStylePreset =
  | 'default'
  | 'emphasis'
  | 'success'
  | 'warning'
  | 'danger'
  | 'muted';

export const SHAPE_STYLE_PRESETS: Record<ShapeStylePreset, ShapeStyle> = {
  default: {
    fillStyle: 'gradient',
    fillColor: '#3b82f6',
    gradientFrom: '#60a5fa',
    gradientTo: '#2563eb',
    borderColor: '#1e3a8a',
    borderWidth: 2,
    borderStyle: 'solid',
    shadow: true,
    opacity: 1,
  },

  emphasis: {
    fillStyle: 'gradient',
    fillColor: '#8b5cf6',
    gradientFrom: '#a78bfa',
    gradientTo: '#7c3aed',
    borderColor: '#5b21b6',
    borderWidth: 2,
    borderStyle: 'solid',
    shadow: true,
    opacity: 1,
  },

  success: {
    fillStyle: 'gradient',
    fillColor: '#22c55e',
    gradientFrom: '#4ade80',
    gradientTo: '#16a34a',
    borderColor: '#166534',
    borderWidth: 2,
    borderStyle: 'solid',
    shadow: true,
    opacity: 1,
  },

  warning: {
    fillStyle: 'gradient',
    fillColor: '#f59e0b',
    gradientFrom: '#fbbf24',
    gradientTo: '#d97706',
    borderColor: '#92400e',
    borderWidth: 2,
    borderStyle: 'solid',
    shadow: true,
    opacity: 1,
  },

  danger: {
    fillStyle: 'gradient',
    fillColor: '#ef4444',
    gradientFrom: '#f87171',
    gradientTo: '#dc2626',
    borderColor: '#7f1d1d',
    borderWidth: 2,
    borderStyle: 'solid',
    shadow: true,
    opacity: 1,
  },

  muted: {
    fillStyle: 'solid',
    fillColor: '#e5e7eb',
    borderColor: '#9ca3af',
    borderWidth: 1,
    borderStyle: 'dashed',
    shadow: false,
    opacity: 0.9,
  },
};

export const DEFAULT_SHAPE_PRESET: ShapeStylePreset = 'default';

export const SHAPE_PRESET_ORDER: ShapeStylePreset[] = [
  'default',
  'emphasis',
  'success',
  'warning',
  'danger',
  'muted',
];
